import React, {useEffect, useState} from "react";
import { Button, Container, Grid, TextField } from "@mui/material";


export const NewMetricForm = ({submit, ...props}) => {
  const [label, setLabel] = useState("");
  const [value, setValue] = useState();
  const [solutionId, setSolutionId] = useState((props.solutionId) ? props.solutionId : "");
  const hasSoln = 'solutionId' in props;

  const submitForm = () => {
    const toReturn = {Label: label, Value: value, SolutionId: solutionId, Solution: null};
    submit(toReturn);
  }


  return (
    <>
      <Grid container spacing={1} justifyContent={"center"}>
        <Grid item xs={5}>
          <TextField 
            variant="outlined"
            label="Metric Name"
            value={label}
            onChange={(e) => setLabel(e.target.value)}
          />
        </Grid>
        <Grid item xs={5}>
          <TextField
            variant="outlined"
            label="Metric Value"
            value={value}
            onChange={(e) => setValue(e.target.value)}
          />
        </Grid>
        {!hasSoln && 
          <Grid item xs={5}>
            <TextField 
              variant="outlined"
              label="Solution Id"
              value={solutionId}
              onChange={(e) => setSolutionId(e.target.value)}
            />
          </Grid>
        }
        <Grid item xs={(hasSoln) ? 10 : 5}>
          <Button onClick={submitForm}>
            Submit
          </Button>
        </Grid>
      </Grid>
    </>
  )
}